import axios from "axios";

export const getAreas = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_areas"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
